module.exports = __webpack_public_path__ + "32327bc40f82212ce138565af21169de.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/img1.jpg
// module id = 534
// module chunks = 0